import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import ElementUI from "element-ui";
import theConfirm from "./components/confirm/confirm.js"; //这里是弹窗确认Confirm
import plugins from "./plugins"; // plugins

// import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/packages/theme-chalk/src/index.scss'
// 覆盖element-ui sass变量的文件夹
import "./styles/element-variables.scss";

import "@/styles/index.css"; //自定义的style
import "./styles/theme.css";

import directive from "./directives"; // 自定义指令
import "./assets/icons"; // icon

import "@/assets/theme.less";
import "@/assets/global.css";

// 引入全局可用阿里图标样式文件
import "@/assets/iconfont/iconfont.css";
// 引入全局可用阿里图标js文件
import "@/assets/iconfont/iconfont.js";
// 引入自己设置的全局icon基础样式，一般用于规定基础的svg宽高和图标大小
import "@/assets/css/font.css";

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

import moment from "moment";

import http from "./api/api";
import md5 from "js-md5";
import * as format from "./utils/format.js";
import BaiduMap from "vue-baidu-map";

import Ellipsis from "@/components/common/Ellipsis";
import WDialog from "@/components/common/WDialog";
import Tip from "@/components/common/Tip";
import failOrderTip from "./utils/websocket/components/failOrderTip.vue";
import dataV from "@jiaminghi/data-view"; // 将dataV全局注册
import { downloadFile } from "@/utils/download";

import Toast from "vue-toastification"; //TODO: 全局消息提醒组件
import "vue-toastification/dist/index.css"; //TODO: 全局消息提醒组件样式
// 生成签名插件
import vueEsign from "vue-esign";
// 引入videojs
import Video from "video.js";
import "video.js/dist/video-js.css";
import hls from "videojs-contrib-hls";
import PortalVue from "portal-vue";
// 文件上传组件
import FileUpload from "@/components/FileUpload"
import Print from 'vue-print-nb'

//地图
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import L from "leaflet";
import "leaflet.chinatmsproviders";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";
import map from "@/utils/leafletMap/map";
Vue.prototype.$map = map;
Vue.L = Vue.prototype.$L = L;

/* leaflet icon */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.config.productionTip = false;

Vue.use(PortalVue); //portal-vue

Vue.use(hls); // 要播放hls流
Vue.use(directive); //TODO: 导入自定义权限
Vue.use(vueEsign);
Vue.use(dataV);
Vue.use(ElementUI);
Vue.use(Ellipsis);
Vue.use(WDialog);
Vue.use(Tip);
Vue.use(plugins);
Vue.use(Viewer);

Vue.use(Print)

Vue.component('FileUpload', FileUpload);


Viewer.setDefaults({
  navbar: false, //底部缩略图
  toolbar: false, //底部工具栏
  button: false, //右上角按钮
  title: false, //当前图片标题
  movable: true, //是否可以移动
  zoomable: true, //是否可以缩放
  transition: false, //使用 CSS3 过度
});

// Vue.use(Toast);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});
// 分页组件
import Pagination from "@/components/Pagination";
// 富文本组件
import Editor from "@/components/Editor";

Vue.use(BaiduMap, {
  ak: "xPNLWkqdUGRQNqT2ze1Hh6bGVoj0GTuk",
});

//TODO:全局挂载组件
Vue.component("failOrderTip", failOrderTip);
Vue.component("Pagination", Pagination);
Vue.component("Editor", Editor);

Vue.prototype.$isNotEmpty = function (obj) {
  return obj !== undefined && obj !== null && obj !== "" && obj !== "null";
};

Vue.prototype.$getDefalut = function (obj, key, df) {
  return obj === undefined || key === undefined || !this.$isNotEmpty(obj[key])
    ? df
    : obj[key];
};

Vue.prototype.$deepCopy = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

import { mixin } from "./mixin/index.js";
// import { approve } from '@/mixin/approve' // 流失审核
import { showLoading, hideLoading } from "@/components/loading/loading";
import filePerview  from "@/utils/filePerview";
import tool from "@/utils/tool.js"
Vue.prototype.$video = Video;

Vue.prototype.$format = format; //格式化js
Vue.prototype.$showLoading = showLoading; //开启加载器
Vue.prototype.$hideLoading = hideLoading; //关闭加载器
Vue.prototype.$http = http; //全局挂载请求体
Vue.prototype.$md5 = md5; //md5加密
Vue.prototype.$confirm2 = theConfirm;
Vue.prototype.$moment = moment;
Vue.prototype.$filePerview = filePerview;
Vue.prototype.$TOOL = tool;//工具

Vue.prototype.downloadFile = downloadFile;

Vue.config.productionTip = false;

Vue.prototype.$echarts = window.echarts;

Vue.use(ElementUI);
Vue.mixin(mixin); //挂载全局公共js文件
// Vue.mixin(approve);//挂载全局公共js文件的

// import '@/utils/flexible';//引用大屏自适应方案的

// 引入主页图表主题
import "./assets/lib/theme/chalk";
import "./assets/lib/theme/vintage";
import "./assets/lib/theme/westeros";

//检测页面是否有变动，有则提示用户
import { createVersionPolling } from "version-polling";
import { MessageBox } from "element-ui";

createVersionPolling({
  eventTriggerList: ["popstate"],
  silent: process.env.NODE_ENV === "development", // 开发环境下不检测
  silentPollingInterval: true,
  onUpdate: (self) => {
    MessageBox.confirm("检测到网页有更新, 是否刷新页面加载最新版本？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    })
      .then(() => {
        self.onRefresh();
      })
      .catch(() => {
        self.onCancel();
      });
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
